import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styled from 'styled-components';
import { StyledLabel } from '../../Components/Label';
const InlineGroup = styled.div `
  height: 38px;
  display: flex;
  flex-wrap: wrap;
  margin-top: ${({ pseudoLabel }) => pseudoLabel && '26px'};
  > ${StyledLabel} {
    margin-bottom: 0;
  }
  > * {
    cursor: pointer;
    &:not(:last-child) {
      margin-right: 15px;
    }
  }
`;
export const Label = styled.span `
  color: ${({ theme }) => theme.colors.grey100_1};
`;
export const Container = styled.label `
  margin-bottom: 0;
  display: inline-flex;
  line-height: 1.35;
  cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'pointer')};
  color: ${({ isDisabled, theme }) => isDisabled && theme.colors.grey100_1};
  &:hover > input + span {
    border-color: ${({ isDisabled, theme }) => !isDisabled && theme.colors.grey70_1};
  }
  > input {
    display: none;
    + span {
      position: relative;
      display: inline-flex;
      width: 18px;
      height: 18px;
      border: 1px solid ${({ theme }) => theme.colors.grey10_1};
      background: ${({ isDisabled, theme }) => (isDisabled ? theme.colors.grey05_3 : theme.colors.grey00_7)};
      border-radius: 100%;
      margin-right: 5px;
      transition: all 100ms;
      flex: 0 0 auto;
      &:after {
        content: '';
        width: 12px;
        height: 12px;
        background: ${({ theme }) => theme.colors.main};
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        margin: auto;
        border-radius: 100%;
        transition: all 0.2s ease;
      }
    }
    &:not(:checked) + span:after {
      opacity: 0;
      transform: scale(0);
    }
    &:checked + span:after {
      opacity: 1;
      transform: scale(1);
    }
  }
`;
const RadioWrapper = ({ dataTestId, children, className, ...props }) => {
    const { disabled } = props;
    return (_jsxs(Container, { className: className, "data-testid": dataTestId, isDisabled: disabled, children: [_jsx("input", { type: 'radio', ...props }), _jsx("span", {}), children] }));
};
const RadioMemo = React.memo(RadioWrapper);
const Radio = (props) => _jsx(RadioMemo, { ...props });
Radio.InlineGroup = InlineGroup;
export { Radio };
